<template>
  <form @submit.prevent="onSearch">
    <div class="row">
<!--            <div class="col-lg-3 col-md-6 col-sm-12">-->
      <!--              <div v-if="officeDropdown && officeDropdown.length">-->
      <!--                <SelectVue-->
      <!--                    v-model="filters.officeId"-->
      <!--                    :options="officeDropdown"-->
      <!--                    :is-clear="true"-->
      <!--                    :placeholder="$t('general.office')"/>-->
      <!--              </div>-->
      <!--            </div>-->
      <div class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.coachId"
            :options="userDropdown"
            :is-clear="true"
            :placeholder="$t('general.employee')"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="!loading">{{ $t('general.button.search') }}</span>
          <span v-else>{{ $t('general.button.search_in_progress') }}</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  userDropdown: {
    type: Array,
    required: true,
  },
});

// Emit search event
const emit = defineEmits([ 'search' ]);

// Use toRefs to maintain reactivity
const { filters }    = toRefs(props);
const officeDropdown = toRefs(props)[ 'officeDropdown' ];
const userDropdown   = toRefs(props)[ 'userDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
